import React from 'react'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import PandaModal from '../../../../components/panda-modal/PandaModal'

type Props = {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
}

const LocationErrorModal = (props: Props) => {
  const { t } = useTranslation()

  return (
    <PandaModal
      isOpen={props.isOpen}
      onClose={() => props.setIsOpen?.(false)}
      actionLabel={t('CLOSE')}
      badge={faLocationDot}
    >
      <p>{t('LOCATION_ERROR')}</p>
    </PandaModal>
  )
}

export default LocationErrorModal
